import Vue from 'vue'
import Vuex from 'vuex'
import * as fb from '../firebase'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    dadosAnuncio: {},
    load: true,
    existes: true
  },
  mutations: {
    setDadosAnuncio(state, val) {
      state.dadosAnuncio = val
    },
    setErro(state, val) {
      state.existes = val
      state.load = false
    }
  },
  actions: {
    // 05ayHGiUAFoJY32Zuf7j / 8ljXxAvvpBIJi4FxMIbV
    // eslint-disable-next-line no-unused-vars
    getDadosAnuncio({ dispatch }, dados) {
      fb.anunciosCollection.doc(dados.id).onSnapshot(async snapshot => {
        if (snapshot.exists){
          let result = snapshot.data()
          if (result.status === 'aprovado')
          fb.publicData.doc(result.id_user).onSnapshot(async snapshot => {
            result.public_data = snapshot.data()
            store.commit('setDadosAnuncio', result)
          })
          else store.commit('setErro', false)
        }else{
          store.commit('setErro', false)
        }
      })
    },
    // async fetchUserProfile({ commit }, user) {
    //   const userProfile = {name: user.uid}//await fb.usersCollection.doc().get()
    //   commit('setUserProfile', userProfile)
    // },
    // async logout({ commit }) {
    //   await fb.auth.signOut()
    //   commit('setUserProfile', {})
    // },
    // // eslint-disable-next-line no-unused-vars
    // async getAnuncios({ dispatch }, data) {
    //   return fb.anunciosCollection
    //       .where('status', '==','aprovado')
    //       .where('isEvaluating', '==', true)
    //       .where('evaluatingBy', '==', data.uid)
    //       .orderBy('data').limit(1).get().then(function (snapshot) {
    //         let dados = '';
    //         let idDoc = '';
    //         if (snapshot.docs.length > 0) {
    //           snapshot.forEach((doc) => {
    //             dados = doc.data()
    //             idDoc = doc.id
    //           });
    //           return {dados, idDoc}
    //         }
    //         else{
    //           return fb.anunciosCollection
    //               .where('status', '==','aprovado')
    //               .where('isEvaluating', '==', false)
    //               .orderBy('data').limit(1).get().then(function (snapshot) {
    //                 if (snapshot.docs.length > 0) {
    //                   snapshot.forEach((doc) => {
    //                     dados = doc.data()
    //                     idDoc = doc.id
    //                   });
    //                 }
    //                 return fb.anunciosCollection.doc(idDoc)
    //                     .update({ isEvaluating: true, evaluatingBy: data.uid })
    //                     .then(function () { return {dados, idDoc}})
    //               })
    //         }
    //       })
    // },
    // // eslint-disable-next-line no-unused-vars
    // async aprovarAnuncio({ dispatch }, data) {
    //   console.log(data.id);
    //   await fb.anunciosCollection.doc(data.id).update({
    //     status: 'aprovado',
    //     userStatus: fb.auth.currentUser.uid,
    //     dateStatus: fb.firebase.firestore.FieldValue.serverTimestamp()
    //   })
    // },
    // // eslint-disable-next-line no-unused-vars
    // async reprovarAnuncio({ dispatch }, data) {
    //   console.log(data.id);
    //   await fb.anunciosCollection.doc(data.id).update({
    //     status: 'reprovado',
    //     motivo_reprovacao: data.motivo_reprovacao,
    //     userStatus: fb.auth.currentUser.uid,
    //     dateStatus: fb.firebase.firestore.FieldValue.serverTimestamp()
    //   })
    // }
  }
});

export default store
